import moment from "moment";
import { normalizePhoneNumber } from "../../../../../utils";
import { UserRole } from "../../../enums/UserRole";
import {
  IAgentBackEndModel,
  IAgentFrontEndModel,
  IParentBackEndModel,
  IParentFrontEndModel,
  ISchoolBackEndModel,
  ISchoolFrontEndModel,
  IServiceProviderBackEndModel,
  IServiceProviderFrontEndModel,
  IStudentBackEndModel,
  IStudentFrontEndModel,
  ISupportBackEndModel,
  ISupportFrontEndModel,
} from "./types";
import { DATE_FORMATS } from "../../../../../constants";

export function parseToAccountBackEndModel(
  data:
    | IStudentFrontEndModel
    | IParentFrontEndModel
    | IAgentFrontEndModel
    | ISchoolFrontEndModel
    | IServiceProviderFrontEndModel
    | ISupportFrontEndModel,
  userRole: UserRole,
) {
  if (userRole === UserRole.School) {
    return parseToSchoolBackEndModel(data as ISchoolFrontEndModel);
  }

  if (userRole === UserRole.ServiceProvider) {
    return parseToServiceProviderBackEndModel(
      data as IServiceProviderFrontEndModel,
    );
  }

  if (userRole === UserRole.Agent) {
    return parseToAgentBackEndModel(data as IAgentFrontEndModel);
  }

  if (userRole === UserRole.Parent) {
    return parseToParentBackEndModel(data as IParentFrontEndModel);
  }

  if (userRole === UserRole.Student) {
    return parseToStudentBackEndModel(data as IStudentFrontEndModel);
  }

  if (userRole === UserRole.Support) {
    return parseToSupportBackEndModel(data as ISupportFrontEndModel);
  }
}

function parseToSchoolBackEndModel(
  data: ISchoolFrontEndModel,
): ISchoolBackEndModel {
  return {
    name: data.name.trim(),
    phone: normalizePhoneNumber(data.phone),
    email: data.email,
    image: data.profileImage,
    schoolProfile: {
      school: {
        name: data.schoolProfile.school.name.trim(),
        country: data.schoolProfile.school.country!.code,
        website: data.schoolProfile.school.website?.trim(),
      },
    },
  };
}

function parseToServiceProviderBackEndModel(
  data: IServiceProviderFrontEndModel,
): IServiceProviderBackEndModel {
  return {
    name: data.name.trim(),
    phone: normalizePhoneNumber(data.phone),
    email: data.email,
    image: data.profileImage,
    serviceProviderProfile: {
      serviceProvider: {
        name: data.serviceProviderProfile.serviceProvider.name.trim(),
        country: data.serviceProviderProfile.serviceProvider.country!.code,
        website: data.serviceProviderProfile.serviceProvider.website?.trim(),
      },
    },
  };
}

function parseToAgentBackEndModel(
  data: IAgentFrontEndModel,
): IAgentBackEndModel {
  return {
    name: data.name.trim(),
    phone: normalizePhoneNumber(data.phone),
    email: data.email,
    image: data.profileImage,
    agentProfile: {
      name: data.agentProfile.name.trim(),
      country: data.agentProfile.country!.code,
      website: data.agentProfile?.website?.trim() || "",
      title: data.agentProfile.title.trim(),
    },
  };
}

function parseToParentBackEndModel(
  data: IParentFrontEndModel,
): IParentBackEndModel {
  return {
    name: data.name.trim(),
    phone: normalizePhoneNumber(data.phone),
    email: data.email,
    image: data.profileImage,
  };
}

function parseToStudentBackEndModel(
  data: IStudentFrontEndModel,
): IStudentBackEndModel {
  return {
    name: data.name.trim(),
    phone: normalizePhoneNumber(data.phone),
    email: data.email,
    image: data.profileImage,
    studentProfile: {
      city: data.studentProfile.city.trim(),
      birth_date: moment(data.studentProfile.birth_date).format(
        DATE_FORMATS.frontEnd,
      ),
      country: data.studentProfile.country!.code,
      citizenship: data.studentProfile.citizenship!.code,
      gender: data.studentProfile.gender!.id,
    },
  };
}

function parseToSupportBackEndModel(
  data: ISupportFrontEndModel,
): ISupportBackEndModel {
  return {
    name: data.name.trim(),
    phone: normalizePhoneNumber(data.phone),
    email: data.email,
    image: data.profileImage,
  };
}
